/**
 * PREFACE
 * Font Awesome Library should be instantiated only once, but the current
 * structure does not allow this. Therefore a library is being pre-packed
 * here and then imported into components that need it.
 *
 * Please note that some icons are still handled by the old installation
 * of font-awesome and are not handled here! Please refer to the list
 * being added to the library and whether or not vue-font-awesome is being
 * used or not.
 *
 * If the answer is yes to both, the icon comes from here :)
 *
 * HOW TO USE
 * Import the icons from an icon package and add those icons to the library.
 * If you do not add them to the library here you cannot use them.
 *
 * ps: Refrain from adding an entire icons package, you do not need several
 * thousand icons to bloat the software ;)
 *
 * USEFUL LINKS
 * http://blog.fontawesome.io/2014/05/19/stacking-text-and-icons
 */

// import { // Custom
//   buildings,
//   group
// } from './custom-icons'

import { type IconDefinition, library } from '@fortawesome/fontawesome-svg-core'

import {
	// Duotone
	faCircle as fadCircle,
	faPlug as fadPlug,
	faSpinnerThird as fadSpinnerThird,
} from '@fortawesome/pro-duotone-svg-icons'
import {
	// Light
	faChartBar as falChartBar,
	faChartPie as falChartPie,
	faCheck as falCheck,
	faCheckCircle as falCheckCircle, // avoid collision between fas/far
	faCircle as falCircle,
	faExclamationCircle as falExclamationCircle,
	faExclamationTriangle as falExclamationTriangle,
	faSignOutAlt as falSignOutAlt,
	faSlash as falSlash,
	faWifi as falWifi,
} from '@fortawesome/pro-light-svg-icons'

library.add(
	// Fal
	falCheckCircle as IconDefinition,
	falExclamationCircle as IconDefinition,
	falWifi as IconDefinition,
	falCircle as IconDefinition,
	falExclamationTriangle as IconDefinition,
	falChartBar as IconDefinition,
	falCheck as IconDefinition,
	falChartPie as IconDefinition,
	falSignOutAlt as IconDefinition,
	falSlash as IconDefinition,
	// Duotone
	fadCircle as IconDefinition,
	fadSpinnerThird as IconDefinition,
	fadPlug as IconDefinition
)
